import { render, staticRenderFns } from "./ProductPage3.vue?vue&type=template&id=34e8db28"
import script from "./ProductPage3.vue?vue&type=script&lang=js"
export * from "./ProductPage3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports